export interface MaskOptions {
  prefix?: string
  decimalSeparator?: string
  groupSeparator?: string
  precision?: number
  groupSize?: number
  secondaryGroupSize?: number
  fractionGroupSeparator?: string
  fractionGroupSize?: number
  suffix?: string
}
